import React from 'react';
import { hashHistory } from 'react-router';
import { Alert, Button, Table, Modal } from 'react-bootstrap';

// import DropDownInput from './common/DropDownInput.jsx';
// import FieldGroup from './common/FieldGroup.jsx';
import { Typeahead } from 'react-bootstrap-typeahead';
import _ from 'lodash'
import '../css/main.css';
import { authContext } from '../AzureAd';

export default class MaintenanceModifyComponent extends React.Component {

	// constructor(props) {
	// 	super(props);
	// }

	goToMaintenanceRefineComponent() {
		//MaintenanceRefineCardsContainer
		hashHistory.push("/refineCards");
	}

	componentDidMount() {
		this.props.findCategories();
	}

	componentWillMount() {
		this.props.findDetails(this.props.request.get("card"));
	}

	toSetDropDownOptions(category) {
		let ret = [];
		if (category && category.checkSets) {
			category.checkSets.map((ckSet, index) => {
				ret.push({ value: ckSet.id, label: ckSet.description, target: ckSet });
			});
		}
		return ret;
	}

	toItemDropDownOptions() {
		let checkSet = this.props.request.get('checkSet');

		let ret = [];
		if (checkSet && checkSet.checkItems) {
			checkSet.checkItems.map((item, index) => {
				if (item.show) {
					ret.push({ value: item.id, label: item.description, target: item });
				}
			});
		}
		return ret;
	}

	detailSets(details) {
		//ref ManageCheckItemComponent
		//1 . 分組 衣 褲 分組
		//sort by cat , by set

		//asyn 先 rendering
		if (details.size === 0) {
			return [];
		}

		let groups = _.groupBy(details, (item) => {
			return item.categoryId
		})

		let clothSets = _.sortBy(groups[1], (detail) => detail.checkSet.id);
		let pantSets = _.sortBy(groups[2], (detail) => detail.checkSet.id);

		let ret = [];
		ret.push(clothSets);
		ret.push(pantSets);
		return ret;
	}

	clothSet(details) {
		if (details.size === 0) {
			return [];
		}
		let gps = this.detailSets(details);
		if (gps[0].length > 0) {
			return gps[0];
		}
		return [];
	}
	pantSet(details) {
		if (details.size === 0) {
			return [];
		}
		let gps = this.detailSets(details);
		if (gps[1].length > 0) {
			return gps[1];
		}
		return [];
	}

	revertDetail(detail) {
		//from removed to pass
		this.props.markDetailAsPass(detail.id, this.props.request.get('card'));
	}

	deleteDetail(detail) {
		if (detail.refineStatus === 'PASS') {
			//from pass to removed
			this.props.markDetailAsRemoved(detail.id, this.props.request.get('card'), authContext.getCachedUser().userName);
		} else
			if (detail.refineStatus === 'APPEND') {
				//delete append 
				if (confirm('移除追加為選項 [' + detail.checkItem.description + ' ]?')) {
					this.props.deleteDetail(detail.id, this.props.request.get('card'));
				}
			}
	}

	unmarkCardAsDiscardClothes(card) {
		this.props.unmarkCardAsDiscardClothes(card);
	}

	markCardAsDiscardClothes(card) {
		this.props.markCardAsDiscardClothes(card);
	}

	unmarkCardAsDiscardPant(card) {
		this.props.unmarkCardAsDiscardPant(card);
	}

	markCardAsDiscardPant(card) {
		this.props.markCardAsDiscardPant(card);
	}

	appendCategoryDescription(category) {
		if (category) {
			return category.description;
		} else {
			return "poiu";
		}
	}

	onCheckSetSelectedControl() {
		let ckSeet = this.props.request.get('checkSet');
		if (ckSeet) {
			return [{ value: ckSeet.id, label: ckSeet.description, target: ckSeet }];
		} else {
			return [];
		}
	}

	onCheckItemSelectedControl() {

		let ckItem = this.props.request.get('checkItem');
		if (ckItem) {
			return [{ value: ckItem.id, label: ckItem.description, target: ckItem }];
		} else {
			return [];
		}
	}

	disableCheckItemOptions() {
		if (this.props.request.get('checkSet')) {
			return false;
		} else {
			return true;
		}
	}

	disableAppendCheckItem() {
		return this.props.request.get('checkSet') == null || this.props.request.get('checkItem') == null;
	}

	appendCheckDetail() {
		let resp = this.props.response;
		let req = this.props.request;
		if (req.get("checkSet") == null || req.get("checkItem") == null) {
			alert("維修項目為必填選項!");
			return;
		}

		let ans = confirm("確認新增維修選項 [ " + req.get("checkItem").description + ' ] ?');
		if (!ans) {
			return;
		}

		let epc;

		if (req.get("category").id == 1) {
			epc = resp.get("card").clothEpc;
		}

		if (req.get("category").id == 2) {
			epc = resp.get("card").pantEpc;
		}


		let editing = {
			cardPk: resp.get("card").id,
			categoryPk: req.get("category").id,
			setPk: req.get("checkSet").id,
			itemPk: req.get("checkItem").id,
			note: req.get("note"),
			epc: epc,
			creator: authContext.getCachedUser().userName,
		};
		this.props.appendCheckDetail(editing);
	}

	disabledAppendModel() {
		let card = this.props.response.get('card');
		if (card && ("REFINED" === card.status || "AUDITED" === card.status)) {
			return true;
		} else {
			return false;
		}
	}

	render() {

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		function viewOnly(card) {
			return card.status === "REFINED" || card.status === "AUDITED";
		}

		function disableDeleteIcon(detail, card) {
			if (viewOnly(card)) {
				return true;
			}
			else {
				if (detail.refineStatus === 'APPEND' || detail.refineStatus === 'PASS') {
					return false;
				} else {
					return true;
				}
			}
		}

		function disableReturnIcon(detail, card) {
			if (viewOnly(card)) {
				return true;
			} else {
				if (detail.refineStatus === 'REMOVED') {
					return false;
				} else {
					return true;
				}
			}

		}

		function deleteIcon(detail, card) {
			if (disableDeleteIcon(detail, card)) {
				return 'delete-grey.svg'
			} else {
				return 'delete.svg'
			}
		}

		function returnIcon(detail, card) {
			if (disableReturnIcon(detail, card)) {
				return 'back-grey.svg'
			} else {
				return 'back.svg'
			}
		}



		let showCheckedIcon = (card, key) => {
			if (card && card[key]) {
				return 'checked.svg';
			} else {
				return 'checkbox.svg';
			}
		}

		let eraseIcon = (detail) => {
			if (detail.refineStatus === 'REMOVED') {
				return <img src='erase.svg' height="30" width="30" title="已取消維修建議" alt="" />;
			} else {
				return '';
			}
		}

		let appendIcon = (detail) => {
			if (detail.refineStatus === 'APPEND') {
				return <img src='cart.svg' height="30" width="30" title="新追加維修選項" alt="" />;
			} else {
				return '';
			}
		}
		let eraseIconNote = (detail) => {
			if (detail.refineStatus === 'REMOVED') {
				return "已取消";
			} else {
				return '';
			}
		}
		let appendIconNote = (detail) => {
			if (detail.refineStatus === 'APPEND') {
				return "新追加";
			} else if (detail.refineStatus === 'DAMAGE') {
				return "破損追加";
			} else if (detail.refineStatus === 'MISSING') {
				return "遺漏追加";
			} else if (detail.refineStatus === 'ESCAPE') {
				return "業主剔除";
			}
			else {
				return '';
			}
		}

		let cardStatus = function (statusKey) {
			switch (statusKey) {
				case 'COMPLETED':
					return '完成清點';
				case 'MODIFIED':
					return '修改清點中';
				case 'REFINED':
					return '已確認';
				case 'AUDITED':
					return '已確認';
				default:
					return "";
			}
		}

		let cardInnfo = () => {
			let ret = [];
			let card = this.props.response.get("card");
			if (card) {
				ret.push(card.code);
				ret.push(card.organization + " " + card.owner);
				ret.push(cardStatus(card.status));
			} else {
				ret.push("");
				ret.push("");
				ret.push("");
			}
			return ret;
		}

		let highlight = function (card) {
			let statusKey = card == null ? "NULL" : card.status;
			switch (statusKey) {
				case 'COMPLETED':
				case 'MODIFIED':
				case 'REFINED':
				case 'AUDITED':
					return {
						textAlign: "center",
					};
				default:
					return {};
			}
		}

		let highlightClassName = function (card) {
			let statusKey = card == null ? "NULL" : card.status;
			switch (statusKey) {
				case 'COMPLETED':
					return "highlight-red";
				case 'MODIFIED':
					return "highlight-brown";
				case 'REFINED':
				case 'AUDITED':
					return "highlight-green";
				default:
					return "";
			}
		}

		return (
			<div>
				<h4>
					作業開工確認 &gt;&gt; 維修表確認修改 &gt;&gt; 修改清點細項&nbsp;
					<a onClick={(e) => { this.goToMaintenanceRefineComponent() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<span hidden>MaintenanceModifyComponent </span>
				<Alert bsStyle={this.props.alert.get('style')} hidden={this.props.alert.get('message') == null}>
					{this.props.alert.get('message')}
				</Alert>

				<table className="main" >
					<tr>
						<th width="14%">訂單編號</th>
						<td width="20%">{this.props.request.get("mcase").orderId} {this.props.request.get("mcase").note}</td>
						<th width="14%">客戶名稱</th>
						<td width="24%">{this.props.request.get("mcase").customer.customerName}</td>
						<th width="13%">建立時間</th>
						<td width="15%">{new Date(this.props.request.get("mcase").createTime).toLocaleDateString()}</td>
					</tr>
					<tr>
						<th width="14%">維修卡號</th>
						<td width="20%" className={"highlight"} style={{ textAlign: "center" }} >{cardInnfo()[0]}</td>
						<th width="14%">使用者名</th>
						<td width="24%">{cardInnfo()[1]}</td>
						<th width="13%">維修卡狀態</th>
						<td width="15%" style={highlight(this.props.response.get("card"))}
							className={highlightClassName(this.props.response.get("card"))}>{cardInnfo()[2]}</td>
					</tr>
				</table>
				<br />
				<div hidden={this.props.response.get("card") && this.props.response.get("card").noClothes}>
					<img alt='shirt' src='shirt.svg' height="40" width="40" />建議不再使用(消防衣)&nbsp;<img alt='' src={showCheckedIcon(this.props.response.get("card"), "discardClothes")} height="35" width="35"
						onClick={(e) => {
							let card = this.props.response.get("card");
							if (card.status === "REFINED" || card.status === "AUDITED") return;

							if (card.discardClothes) {
								this.unmarkCardAsDiscardClothes(card);
							} else {
								this.markCardAsDiscardClothes(card);
							}
						}
						} />
					<Table striped bordered condensed hover >
						<thead>
							<tr>
								<th colSpan='5'>消防衣維修項目</th>
								<th>Note</th>
								<th width="5%" colSpan='2' style={alignCenter}><Button bsSize='small' bsStyle="info"
									onClick={
										(event) => {
											this.props.showAppendModal(this.props.response.get('card'), this.props.categories[0]);
										}
									}

									disabled={this.disabledAppendModel()}
								>+</Button></th>
							</tr>
						</thead>
						<tbody>
							{
								this.clothSet(this.props.response.get("details")).map(
									(detail, index) => {
										let card = this.props.response.get('card');

										return <tr key={index}>
											<td width="3%">{index + 1}</td>
											<td width="5%" style={alignCenter}>{eraseIcon(detail)}{appendIcon(detail)}</td>
											<td width="15%">{detail.checkSet.description}</td>
											<td width="25%">{detail.checkItem.description}</td>
											<td width="10%">{eraseIconNote(detail)}{appendIconNote(detail)}</td>
											<td>{detail.note}</td>
											<td width="5%" style={alignCenter}>
												<a >
													<Button disabled={disableDeleteIcon(detail, card)} onClick={
														(event) => {
															this.deleteDetail(detail);
														}
													} title="移除選項">
														<img src={deleteIcon(detail, card)} height="20" width="20" alt="" />
													</Button>
												</a>
											</td>
											<td width="5%" style={alignCenter}>
												<a >
													<Button disabled={disableReturnIcon(detail, card)} onClick={
														(event) => {
															this.revertDetail(detail);
														}
													} title="復原">
														<img src={returnIcon(detail, card)} height="20" width="20" alt="" />
													</Button>
												</a>
											</td>
										</tr>
									}
								)
							}
						</tbody>
					</Table>
				</div>
				<br />
				<div hidden={this.props.response.get("card") && this.props.response.get("card").noPant}>
					<img alt='shorts' src='shorts.svg' height="40" width="40" />建議不再使用(消防褲)&nbsp;<img alt='' src={showCheckedIcon(this.props.response.get("card"), "discardPant")} height="35" width="35"
						onClick={(e) => {
							let card = this.props.response.get("card");
							if (card.status === "REFINED" || card.status === "AUDITED") return;
							if (card.discardPant) {
								this.unmarkCardAsDiscardPant(card);
							} else {
								this.markCardAsDiscardPant(card);
							}
						}
						} />
					<Table striped bordered condensed hover >
						<thead>
							<tr>
								<th colSpan='5'>消防褲維修項目</th>
								<th>Note</th>
								<th width="5%" colSpan='2' style={alignCenter}><Button bsSize='small' bsStyle="info"
									onClick={
										(event) => {
											this.props.showAppendModal(this.props.response.get('card'), this.props.categories[1]);
										}
									}
									disabled={this.disabledAppendModel()}
								>+</Button></th>
							</tr>
						</thead>
						<tbody>
							{
								this.pantSet(this.props.response.get("details")).map(
									(detail, index) => {
										let card = this.props.response.get('card');
										return <tr key={index}>
											<td width="3%">{index + 1}</td>
											<td width="5%" style={alignCenter}>{eraseIcon(detail)}{appendIcon(detail)}</td>
											<td width="15%">{detail.checkSet.description}</td>
											<td width="25%">{detail.checkItem.description}</td>
											<td width="10%">{eraseIconNote(detail)}{appendIconNote(detail)}</td>
											<td>{detail.note}</td>
											<td width="5%" style={alignCenter}>
												<a>
													<Button disabled={disableDeleteIcon(detail, card)} onClick={
														(event) => {
															this.deleteDetail(detail);
														}
													} title="移除選項">
														<img src={deleteIcon(detail, card)} height="20" width="20" alt="" />
													</Button>
												</a>
											</td>
											<td width="5%" style={alignCenter}>
												<a>
													<Button disabled={disableReturnIcon(detail, card)} onClick={
														(event) => {
															this.revertDetail(detail);
														}
													} title="復原">
														<img src={returnIcon(detail, card)} height="20" width="20" alt="" />
													</Button>
												</a>
											</td>
										</tr>
									}
								)
							}
						</tbody>
					</Table>
				</div>

				<Modal show={this.props.request.get('showAdd')} onHide={this.props.hideAddModal} backdrop="static">
					<Modal.Header closeButton >
						<Modal.Title id="append-checked-item">追加清點項目</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<span hidden> MaintenanceModifyComponent.Modal </span>
						<h4>[{
							this.appendCategoryDescription(this.props.request.get('category'))
						}] 追加清點項目</h4>
						<Table striped bordered condensed hover >
							<tbody>
								<tr>
									<th>&nbsp;&nbsp;維修類別</th>
									<td>
										<Typeahead
											onChange={(selecteds) => {
												if (selecteds[0]) {
													this.props.assignAppendSet(selecteds[0].target);
													this.itemOption.getInstance().clear();
												}
											}}
											options={this.toSetDropDownOptions(this.props.request.get('category'))}
											selected={this.onCheckSetSelectedControl()}
										//disabled
										/>
									</td>
								</tr>
								<tr>
									<th>&nbsp;&nbsp;清點細項</th>
									<td>
										<Typeahead
											ref={(ref) => this.itemOption = ref}
											clearButton
											onChange={(selecteds) => {
												if (selecteds[0]) {
													this.props.assignAppendItem(selecteds[0].target);
												}
											}}
											options={this.toItemDropDownOptions(this.props.request.get('checkSet'))}
											selected={this.onCheckItemSelectedControl()}
											disabled={this.disableCheckItemOptions()}
										/>
									</td>
								</tr>
								<tr>
									<th>&nbsp;&nbsp;附註</th>
									<td>
										<input type="text" className='form-control'
											onChange={(e) => {
												this.props.assignAppendNote(e.target.value);
											}}
											value={this.props.request.get('note')}
										/>
									</td>
								</tr>
								<tr>
									<th>&nbsp;&nbsp;</th>
									<td>
										<Button onClick={(event) => { this.appendCheckDetail() }}
											disabled={this.disableAppendCheckItem()}
										>追加</Button>&nbsp;&nbsp;&nbsp;<Button onClick={(event) => { this.props.hideAddModal() }} >取消</Button>
									</td>
								</tr>
							</tbody>
						</Table>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={(event) => { this.props.hideAddModal() }} >離開</Button>
					</Modal.Footer>
				</Modal>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceModifyComponent.jsx